import { Box, Card, Typography } from '@mui/material';
import React from 'react';
import ReactApexChart from 'react-apexcharts';
import { AppUtils } from '../../../utils/appUtils';
import MessageBlock from '../../../pages/admin/components/message-block/MessageBlock';
import { NO_RECORDS_FOUND } from '../../../utils/constants';

const monthMapping = {
  BAISAK: "बैशाख",
  JESTHA: "जेष्ठ",
  ASHAD: "अषाढ",
  SHRAWAN: "श्रावण",
  BHADRA: "भाद्र",
  ASHWIN: "आश्विन",
  KARTIK: "कार्तिक",
  MANGSIR: "मंसिर",
  POUSH: "पौष",
  MAGH: "माघ",
  FALGUN: "फाल्गुण",
  CHAITRA: "चैत्र",
};

const ChartDataByNewOldPatient = ({ chartDataByNewOld }) => {
  if (!chartDataByNewOld || !chartDataByNewOld.PATIENT_TYPE_DATA) return null;

  const { NEW_PATIENT, PREVIOUS_PATIENT } = chartDataByNewOld.PATIENT_TYPE_DATA;

  // Convert API response to a format usable by ApexCharts
  const months = Object.keys(monthMapping);
  const chartData = months
    .map((monthKey) => ({
      month: monthMapping[monthKey],
      newPatients: NEW_PATIENT[monthKey] || 0,
      oldPatients: PREVIOUS_PATIENT[monthKey] || 0,
    }))
    .filter(item => item.newPatients !== 0 || item.oldPatients !== 0); // Remove months with both values as 0

  const options = {
    chart: {
      type: 'bar',
      height: 430
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: '50%',
        endingShape: 'rounded',
      },
    },
    tooltip: {
      enabled: true,
      y: {
        formatter: (val) => `${AppUtils.replaceWithNepaliDigit(val)} जना`,
      },
    },
    dataLabels: {
      enabled: true,
      formatter: (val) => `${AppUtils.replaceWithNepaliDigit(val)} जना`,
      style: {
        fontSize: '12px',
      }
    },
    xaxis: {
      categories: chartData.map(item => item.month),
      title: {
        text: "महिना"
      }
    },
    yaxis: {
      title: {
        text: "जम्मा संख्या"
      }
    },
    title: {
      text: "सेवाग्राहीको किसिम अनुसार चालु आ. व. को सेवाग्राही विवरण",
      align: "center",
      style: {
        fontSize: "15px",
      },
    },
    legend: {
      position: 'top',
    },
  };

  const series = [
    { name: 'नयाँ बिरामीहरू', data: chartData.map(item => item.newPatients) },
    { name: 'पुराना बिरामीहरु', data: chartData.map(item => item.oldPatients) }
  ];

  return (
    <Box mt={2}>
      <Card>
        {chartData.length > 0 ? <ReactApexChart options={options} series={series} type="bar" height={430} /> : (
          <MessageBlock text={NO_RECORDS_FOUND} />
        )}
      </Card>
    </Box>
  );
};

export default ChartDataByNewOldPatient;
